module.exports = "<itpx-uploader\n    [cancelRoute]=\"cancelRoute\"\n    [component]=\"component\"\n    [saveRoute]=\"saveRoute\"\n    [imgSrc]=\"imgSrc\"\n    [type]=\"type\"\n    [name]=\"name\"\n    [bucket]=\"bucket\">\n</itpx-uploader>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/agora/components/account-data/accounts/edit/update-branded-logo/update-branded-logo.component.html
// module id = ./src/app/agora/components/account-data/accounts/edit/update-branded-logo/update-branded-logo.component.html
// module chunks = main